import { t } from 'i18next'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { InputDatePicker, InputText } from '../../components/Main'
import Validation, {
  correctionNoteMaxLength,
  correctionNoteMinLength,
  titleMaxLength,
  titleMinLength,
} from '../../constant/global/validation'
import { InteractorReturnCreate, InteractorOrderSearch } from '../../interactors/Main'
import InteractorShippingHeaderSearch from '../../interactors/transaction/shipping/InteractorShippingHeaderSearch'
import ReturnItemsSection from './ReturnItemsSection'
import { confirmationAlert, showAlert } from '../../utility/SweetAlert'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { formatDate } from '../../utility/Helpers'

const ReturnCreate = () => {
  const refOrder = useRef(null)
  const { account } = useSelector((state) => state.account)
  const { returnCreate } = InteractorReturnCreate()
  const { orderSearch } = InteractorOrderSearch()
  const { shippingHeaderSearch } = InteractorShippingHeaderSearch()
  const { validationInputText, validationInputChar } = Validation()
  const [loading, setLoading] = useState(true)
  const [loadingShipping, setLoadingShipping] = useState(true)
  const [returnItems, setReturnItems] = useState([])
  const [returnTotal, setReturnTotal] = useState({
    shippingCost: 0,
    insuranceCost: 0,
    totalOrder: 0,
    totalPayment: 0,
    unappliedDownPayment: 0,
  })
  const [orderData, setOrderData] = useState({})
  const [dataShipping, setDataShipping] = useState([])
  const [orderDataList, setOrderDataList] = useState([])
  const [selectedCode, setSelectedCode] = useState(null)
  const [detailReturn, setDetailReturn] = useState({
    created_date: new Date(),
    retur_attachment: null,
  })
  const [error, setError] = useState({
    order_number: null,
    retur_note: null,
    created_date: null,
    retur_attachment: null,
  })
  const [openOrder, setOpenOrder] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  // const isOrderReady = !!orderData.uid
  // const isShippingReady = dataShipping?.items !== undefined
  // const billRaw = orderData?.bill ?? '[]'
  // const [finalResult, setFinalResult] = useState(null)

  // const checkBillStatus = useMemo(() => {
  //   try {
  //     return JSON.parse(billRaw).some((b) => ['ISSUED', 'PROCESSED'].includes(b.status))
  //   } catch {
  //     return false
  //   }
  // }, [billRaw])

  // const hasShippedStatus = useMemo(() => {
  //   if (!Array.isArray(dataShipping?.items) || dataShipping.items.length === 0) return false
  //   return dataShipping.items.some(
  //     (it) => !['DELIVERED', 'CANCELLED', 'CORRECTION'].includes(it.initial_status),
  //   )
  // }, [dataShipping?.items])

  const payloadOrderSearch = useMemo(
    () => ({
      page: 1,
      limit: 100,
      keywords: {
        text_search: '',
        status: 'COMPLETED',
        payment_type: '',
        account_uid: account.uid,
        store_uid: '',
        retur_available: 'Y',
      },
    }),
    [account.uid],
  )

  const [payloadShipping, setPayloadShipping] = useState({
    page: 1,
    limit: 50,
    keywords: {
      text_search: '',
      uid: '',
      transaction_uid: '',
      account_uid: account?.uid,
      status: '',
      store_uid: '',
    },
  })

  const handleResponseShipping = useCallback((data) => {
    if (data?.items) {
      const shipingData = data.items.filter((item) => item.initial_status === 'DELIVERED')
      setDataShipping(shipingData)
    }
  }, [])

  useEffect(() => {
    if (loadingShipping && selectedCode) {
      shippingHeaderSearch(payloadShipping, handleResponseShipping, () => {
        setLoadingShipping(false)
      })
    }
  }, [selectedCode, loadingShipping, payloadShipping, shippingHeaderSearch, handleResponseShipping])

  // useEffect(() => {
  //   if (!isOrderReady || !isShippingReady) return

  //   if (finalResult !== null) return

  //   const shouldStay =
  //     (!hasShippedStatus && !checkBillStatus) ||
  //     (orderData?.bill === undefined && dataShipping?.items === null)

  //   setFinalResult(shouldStay)
  // }, [
  //   isOrderReady,
  //   isShippingReady,
  //   hasShippedStatus,
  //   checkBillStatus,
  //   dataShipping?.items,
  //   finalResult,
  //   orderData?.bill,
  // ])

  // useEffect(() => {
  //   if (finalResult === null) return

  //   if (!finalResult) window.location.href = `/return/${uid}`
  // }, [finalResult, uid])

  const filteredOrders = orderDataList.filter((item) =>
    item?.transaction_code?.toLowerCase()?.includes(searchQuery.toLowerCase()),
  )

  const handleSelectOrder = (val) => {
    setSelectedCode(val.transaction_code)
    setOrderData(val || {})
    setReturnItems([])
    setReturnTotal({
      shippingCost: 0,
      totalOrder: 0,
    })

    handlerInput({
      target: { name: 'transaction_code', value: val.transaction_code },
    })

    setPayloadShipping((prev) => ({
      ...prev,
      keywords: {
        ...prev.keywords,
        transaction_uid: val.uid,
      },
    }))

    setLoadingShipping(true)
    setSearchQuery('') // Reset search setelah pilih
    setOpenOrder(false) // Tutup dropdown
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refOrder.current && !refOrder.current.contains(event.target)) {
        setOpenOrder(false)
        setSearchQuery('')
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [refOrder])

  const handlerInput = (e) => {
    const { name, value } = e.target

    let message = null
    if (name === 'retur_note') {
      message = validationInputChar(
        value,
        correctionNoteMinLength,
        correctionNoteMaxLength,
        t(`form.${name}`),
      )
    } else {
      message = validationInputText(value, titleMinLength, titleMaxLength, t(`form.${name}`))
    }
    setError((prev) => ({ ...prev, [name]: message }))

    setDetailReturn({
      ...detailReturn,
      [name]: value,
    })
  }

  const datePickHandler = (value) => {
    setDetailReturn({
      ...detailReturn,
      created_date: value,
    })
  }

  const parsingItems = () => {
    const items = []
    const filterReturnItems = returnItems.filter((i) => i.is_deleted === 0)
    filterReturnItems.forEach((val) => {
      items.push({
        created_by: val.created_by,
        transaction_item_uid: val.transaction_item_uid,
        transaction_shipping_header_uid: val.transaction_shipping_header_uid,
        product_uid: val.product_uid,
        product_title: val.product_title,
        product_price: val.product_price,
        product_tax: val.product_tax,
        product_quantity: val.product_quantity,
        product_quantity_before: val.product_quantity_before,
        product_type: val.product_type,
        product_unit_type: val.product_unit_type,
        retur_reason: detailReturn?.retur_note,
        shipping_code: val.shipping_code,
      })
    })
    return items
  }

  const handleOrderSearch = useCallback((response) => {
    if (response?.items) {
      const orderResponse = response?.items
      setOrderDataList(orderResponse)
    } else {
      setOrderDataList([])
    }
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()

    const returItems = parsingItems()
    const minSubtotalProduct = 0.5
    const payload = {
      created_by: account?.full_name,
      transaction_uid: orderData?.uid,
      transaction_code: detailReturn?.transaction_code,
      status: 'REQUEST',
      reference_number_internal: detailReturn?.reference_number_internal || null,
      customer_account_uid: orderData?.customer_account_uid,
      customer_company_uid: orderData?.customer_company_uid || null,
      created_date: formatDate(detailReturn.created_date, 'YYYY-MM-DD HH:mm:ss'),
      store_uid: orderData?.store_uid,
      retur_amount: returnTotal?.totalOrder,
      retur_note: detailReturn?.retur_note,
      retur_attachment: detailReturn?.retur_attachment?.length
        ? detailReturn?.retur_attachment?.join(',')
        : '',
      retur_lines: returItems,
    }

    if (returnTotal.totalOrder < minSubtotalProduct) {
      showAlert({
        icon: 'error',
        message: t('message.subtotal_minimum'),
        reload: true,
        timer: 3000,
      })
      return
    }
    const anyZeroPriceReturn = returItems.some((item) => item.after_product_price === 0)
    if (anyZeroPriceReturn) {
      showAlert({
        icon: 'error',
        message: t('message.less_than_minimum_nominal'),
        reload: true,
        timer: 3000,
      })
      return
    }

    if (returnItems.length < 1) {
      showAlert({
        icon: 'error',
        message: t('message.no_items_return'),
        reload: false,
        timer: 3000,
      })
      return
    }

    let checkZeroQuantity = returItems.find((item) => item.product_quantity === 0)
    if (checkZeroQuantity) {
      showAlert({
        icon: 'error',
        message: t('message.invalid_quantity'),
        reload: false,
        timer: 3000,
      })
      return
    }

    const checkMaxProduct = Object.keys(error).some(
      (key) => key.startsWith('product_quantity_') && error[key] !== null,
    )

    if (checkMaxProduct) {
      showAlert({
        icon: 'error',
        message: t('message.maximum_quantity'),
        reload: false,
      })
      return
    }

    if (error.created_date || error.retur_note) {
      showAlert({
        icon: 'error',
        message: error.created_date || error.retur_note,
        reload: false,
      })
      return
    }

    if (!detailReturn?.retur_note) {
      let message = validationInputChar(
        '',
        correctionNoteMinLength,
        correctionNoteMaxLength,
        t(`form.retur_note`),
      )
      showAlert({
        icon: 'error',
        message,
        reload: false,
      })
      return
    }

    const confirm = await confirmationAlert({
      title: t('title.are_you_sure'),
      message: t('message.confirmation_return_product'),
      icon: 'warning',
    })

    if (confirm) {
      returnCreate(payload, setLoading, orderData?.uid)
    }
    setLoading(true)
  }

  useEffect(() => {
    if (loading) {
      orderSearch(payloadOrderSearch, handleOrderSearch, () => {})
    }
  }, [orderSearch, loading, payloadOrderSearch, handleOrderSearch])

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between mb-3">
        <h6 className="text-primary fw-bold">{t('form.return_create_title')}</h6>
        <Link
          to={'#'}
          onClick={() => {
            window.location = `/return`
          }}
          className="text-dark btn-outline-secondary btn btn-xs m-2 font-size-12"
        >
          <i className="fas fa-arrow-left px-2"></i> {t('button.back')}
        </Link>
      </div>
      <div className="card p-3 mb-4">
        <div className="row g-3 mb-4">
          <div className="col-md-6 pb-2 pt-1">
            <label className="align-items-md-left font-size-12 font-weight-bold form-label">
              {t('form.return_date')}
            </label>
            <InputDatePicker
              initial="DDMMYY"
              required={true}
              onCallback={datePickHandler}
              maxDate={new Date()}
              startDate={new Date()}
              disabled={true}
            />
          </div>
          <div className="col-md-6 pb-2 pt-1">
            <label className="align-items-md-left font-size-12 font-weight-bold form-label">
              {t('title.order_number')}
            </label>
            <div className="position-relative" ref={refOrder}>
              <div
                className={`form-control d-flex align-items-center ${
                  !!error.order_number ? 'is-invalid' : ''
                }`}
                style={{ cursor: 'text', height: 'auto' }}
                onClick={() => setOpenOrder(true)}
              >
                <input
                  key="select_order"
                  type="text"
                  className="border-0 w-100"
                  placeholder={detailReturn?.order_number || t('title.select_order')}
                  value={searchQuery || selectedCode || ''}
                  onChange={(e) => {
                    if (selectedCode) setSelectedCode(null)

                    setSearchQuery(e.target.value)
                    setOpenOrder(true)
                  }}
                  onFocus={() => setOpenOrder(true)}
                />
                <i
                  className={`fa ${
                    openOrder ? 'fa-chevron-up' : 'fa-chevron-down'
                  } ms-2 text-muted`}
                  style={{ fontSize: 12 }}
                ></i>
              </div>
              {openOrder && (
                <ul
                  className="list-group position-absolute w-100 mt-1 shadow"
                  style={{
                    zIndex: 9999,
                    maxHeight: 200,
                    overflowY: 'auto',
                    borderRadius: 8,
                    backgroundColor: 'white',
                    padding: 0,
                  }}
                >
                  {filteredOrders.length > 0 ? (
                    filteredOrders.map((item) => {
                      const isSelected = selectedCode === item.transaction_code
                      return (
                        <li
                          key={item.transaction_code}
                          className={`list-group-item list-group-item-action ${
                            isSelected ? 'active' : ''
                          }`}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSelectOrder(item)}
                        >
                          {item.transaction_code}
                        </li>
                      )
                    })
                  ) : (
                    <li className="list-group-item text-muted small">
                      {t('form.not_found_order')}
                    </li>
                  )}
                </ul>
              )}
              {error.order_number && (
                <div className="invalid-feedback d-block">{error.order_number}</div>
              )}
            </div>
          </div>
          <div className="col-md-6 pb-2 pt-1">
            <InputText
              label={t('form.reference_number_internal')}
              value={detailReturn?.reference_number_internal || ''}
              maxLength={20}
              onChange={handlerInput}
              name="reference_number_internal"
              placeholder={t('form.reference_number_internal')}
            />
          </div>
          <div className="col-md-6 pb-2 pt-1">
            {/* <label className="font-size-12 font-weight-bold">
              {t('form.return_approved_date')} / {t('form.return_rejected_date')}
            </label> */}
            <InputText
              label={`${t('form.return_approved_date')} / ${t('form.return_rejected_date')}`}
              value={null}
              disable
            />
          </div>
          <div className="col-12 pb-2">
            <InputText
              label={t('form.retur_note')}
              value={detailReturn?.retur_note || ''}
              placeholder={t('form.retur_note')}
              onChange={handlerInput}
              error={!!error.retur_note}
              errorMsg={error.retur_note}
              name="retur_note"
              required={true}
            />
          </div>
        </div>
        <ReturnItemsSection
          label={t('form.return_shipping')}
          orderData={orderData}
          dataShipping={dataShipping}
          items={returnItems}
          setItems={setReturnItems}
          totalData={returnTotal}
          setTotalData={setReturnTotal}
          detailReturn={detailReturn}
          setDetailReturn={setDetailReturn}
          error={error}
          setError={setError}
        />
      </div>

      <div className="text-center mt-4">
        <button className="btn btn-primary px-4 pointer" onClick={handleSubmit}>
          {t('button.save')}
        </button>
      </div>
    </div>
  )
}

export default ReturnCreate
